import { ANALYTICS_IDLE_LOAD_FALLBACK_MS } from "./mix-panel-constant";

type MixpanelModule = typeof import("./mix-panel-util");

let loader: Promise<MixpanelModule> | null = null;

/** Loads and initialises Mixpanel on first call so the SDK stays off the startup path. */
export const loadMixpanel = (): Promise<MixpanelModule> => {
  if (!loader) loader = import("./mix-panel-util");
  return loader;
};

/** Runs `callback` only if Mixpanel is already loaded — never loads it just to run the callback. */
export const withLoadedMixpanel = (
  callback: (mixpanel: MixpanelModule) => void
): void => {
  if (!loader) return;
  void loader.then(callback);
};

/** Defers the Mixpanel load until the browser is idle after first paint. */
export const scheduleMixpanelLoad = (): void => {
  const load = () => void loadMixpanel().catch(() => undefined);

  if (typeof window.requestIdleCallback === "function") {
    window.requestIdleCallback(load);
    return;
  }

  window.setTimeout(load, ANALYTICS_IDLE_LOAD_FALLBACK_MS);
};
